import type { RootState } from 'typesafe-actions';

import type { ExperimentsState } from './reducer';

export const getExperiments = (state: RootState): ExperimentsState => state.experiments;

export const getUserId = (state: RootState) => getExperiments(state).userId;

export const getExperimentsConfig = (state: RootState) => getExperiments(state).config;

export const getIsFetching = (state: RootState) => getExperiments(state).isFetching;

export const getErrors = (state: RootState) => getExperiments(state).errors;
